import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.04 2.827a5.555 5.555 0 0 0-.016 1.19 5 5 0 1 0 1.97 3.72c.305.253.638.474.993.657a6.002 6.002 0 0 1-3.352 4.998A9.004 9.004 0 0 1 21 22a.5.5 0 1 1-1 0 8 8 0 1 0-16 0 .5.5 0 1 1-1 0 9.004 9.004 0 0 1 6.365-8.608A6 6 0 1 1 15.04 2.827zm5.941 1.16l-.013 2.626c-.001.214-.218.387-.484.387h-.002c-.267 0-.483-.176-.482-.39l.014-2.629-2.627-.013c-.214-.001-.388-.219-.387-.486 0-.267.175-.482.389-.482h.002l2.628.014.013-2.627c.001-.214.218-.387.484-.387h.002c.267 0 .483.176.482.39l-.014 2.629 2.627.013c.214.001.388.219.387.486 0 .267-.175.482-.389.482h-.002l-2.628-.014z"
});

var SvgPersonAdd = function SvgPersonAdd(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgPersonAdd;